import { lazy, Suspense, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Dialog from '@rewardopl/react-ui/dialog';

import LoadingText from './loading_text';

const TermsAndConditions = lazy(() => import('./terms_and_conditions'));

export default function TermsAndConditionsDialog() {
  const location = useLocation();
  const navigate = useNavigate();

  const close = useCallback(() => {
    navigate(
      {
        ...location,
        hash: '',
      },
      { state: location.state },
    );
  }, [location, navigate]);

  return (
    <Dialog
      isOpen={location.hash === '#terms-and-conditions'}
      onDismiss={close}
      title="Terms and Conditions"
    >
      <Suspense fallback={<LoadingText />}>
        <TermsAndConditions />
      </Suspense>
    </Dialog>
  );
}
